import * as React from 'react';

import FameProgressWrapper from 'containers/molecules/Fame/ProgressWrapper/FameProgressWrapper';
import FameStage from 'containers/molecules/Fame/Stage/FameStage';
import FameSuccess from 'containers/molecules/Fame/Success/FameSuccess';

import Loader from 'components/atoms/Loader';
import withSequenceState from 'components/hoc/withSequenceState';
import Sequences from 'defs/sequences';

import withVirtualPageView from 'components/hoc/withVirtualPageView';
import { WithVirtualPageView } from 'components/hoc/withVirtualPageView';

type MySuccessProps = WithVirtualPageView & {
	hasDataInState: boolean;
	isSequenceLoading?: boolean;
	doRequestMySuccess: Function;
	doRequestMySuccessLevels: Function;
};

type MySuccessState = {};

export class MySuccess extends React.Component<MySuccessProps, MySuccessState> {
	public static displayName = 'MySuccess';

	public tracked = false;

	public componentDidMount() {
		this.props.doRequestMySuccess();
		this.props.doRequestMySuccessLevels();
	}

	public render() {
		const { isSequenceLoading, hasDataInState, trackVirtualPageView } = this.props;

		if (isSequenceLoading && !hasDataInState) {
			return <Loader />;
		}

		if (!this.tracked) {
			trackVirtualPageView({});
			this.tracked = true;
		}

		return (
			<React.Fragment>
				<FameStage />
				<FameProgressWrapper {...({} as any)} />
				<FameSuccess />
			</React.Fragment>
		);
	}
}
export default withSequenceState(withVirtualPageView(MySuccess), [Sequences.LOAD_MY_SUCCESS_HALL_OF_FAME]);
